'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name mobileSearch
    * @description Initializes special search behavior for mobile
    **/

    // Needs only be initialized once per page
    var initializeMobileSearch = function () {
        var $locationSearchForm = $('.locationSearch form');
        if ($locationSearchForm.length > 0) {
            var $searchInputs = $locationSearchForm.find('select.destinationDD, select.homeMonthDD');
            var $searchSubmitBtn = $locationSearchForm.find('[type="submit"]');
            if ($searchInputs.length > 0) {
                $searchInputs.on('change', function () {
                    // only use insta click on tablet and below
                    if ($searchSubmitBtn.is(':hidden') || $searchSubmitBtn.length <= 0) {
                        $locationSearchForm.submit();
                    }
                });
            }

        }
    };

    // Return an object exposing the public items
    return {
        initialize: initializeMobileSearch
    };
}())
